import React from 'react'

import Paper from "@mui/material/Paper"
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import Select from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'
import CircularProgress from "@mui/material/CircularProgress"

import {Context as AppContext}  from '../../contexts/App'
import {Context as NotificationsContext}  from '../../contexts/Notifications'
import DropZone from '../../components/Dropzone'
import config from '../../config.json'


import Tags from '../../components/Tags'
import { Alert } from '@mui/material'
import { roleCheck } from '../../contexts/Auth'

const failedBulkCost = 'Products-productBulkUpdate'
const failedBulkunauthorized = 'Products-productBulkUpdate'
const user_roles = ["system_manager"]

const UpdateProductCosts = () => {

  const { products, suppliers, clients, currencies } = React.useContext(AppContext)
  const { createSnack, openSnack, deleteSnack } = React.useContext(NotificationsContext)

  React.useEffect(() => {
    createSnack(failedBulkCost, {message: "Falló la actualización de costos de productos"})
    return () => deleteSnack(failedBulkCost)
  }, [])

  React.useEffect(() => {
    createSnack(failedBulkunauthorized, {message: "Acceso no autorizado"})
    return () => deleteSnack(failedBulkunauthorized)
  }, [])

  const onError = (e) => {
    enable()
    if (e.status===403){
      openSnack(failedBulkunauthorized)
    }else{
      openSnack(failedBulkCost)
    }
  }

  const enable = (download) => {
    if(download){
      console.log("downloading publicityFile from source: ", config.api_url+download)
      window.open(config.api_url+download, "_blank")
    }
    setDisabled(false)
  }
  
  const [disabled, setDisabled] = React.useState(false)
  const [files, setFiles] = React.useState([])

  const supplierRef = React.createRef()
  const clientRef = React.createRef()
  const tagsRef = React.createRef()
  const switchRef = React.createRef()

  const submitFile = e => {
    e.stopPropagation()
    setDisabled(true)
    const data = new FormData()
    const costs = files[0]
    console.log("supplierRef", supplierRef.current)
    supplierRef.current && data.append("supplier", supplierRef.current.value)
    clientRef.current && data.append("client", clientRef.current.value)
    tagsRef.current && data.append("tags", tagsRef.current.querySelector('input').value.split(','))
    switchRef.current && data.append("sync", switchRef.current.checked?1:0)

    data.append("productBulkUpdate", costs)
    products.productBulkUpdate(data, enable, onError)
  }
  const columnKeys = Object.keys(config.updateProductColumns)
  const copyColumns = () => {
    const columnTexts = columnKeys.join('\t');
    navigator.clipboard.writeText(columnTexts).then(() => {
      alert('Nombres de columnas copiadas');
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

  const flag = files.length > 0

  return (
    <div style={{
      display: 'flex',
      justifyContent: "center",
      margin: 'auto',
      width: 400,
      flexWrap: 'wrap',
    }}>
      <div style={{ width: '100%', float: 'left', marginBottom: '30px'}}>
        <h3>Actualizar productos</h3> <br />
        <Typography>Se aceptan las siguientes columnas:</Typography>
        <ul>
          {columnKeys.map(k => 
              k === "moneda"? (<li key={k}><strong>{k}</strong>&emsp; { currencies.currencies.map(c => c.name).join(', ') }</li>)
              : (<li key={k}><strong>{k}</strong>&emsp; {config.updateProductColumns[k]}</li>)
            )
          }

        </ul>
        <Button onClick={copyColumns}>Copiar columnas</Button>
      </div>
        {roleCheck(user_roles)?
        <Paper sx={{ cursor: flag?'auto':'pointer', position: 'relative', minWidth:"200px", minHeight: '200px', display: "flex", justifyContent: "space-around", alignItems: "center", flexDirection: "column",padding: "15px"}}>
          <FormControl sx={{ m: 1, width: '25ch' }}>
            <InputLabel id="client-label">Cliente</InputLabel>
            <Select label="client-label" defaultValue={0} inputRef={clientRef}>
              <MenuItem value={0}>Todos</MenuItem>
              {clients.clients && clients.clients.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, width: '25ch' }}>
            <InputLabel id="supplier-label">Proveedor</InputLabel>
            <Select label="supplier-label" defaultValue={0} inputRef={supplierRef}>
              <MenuItem value={0}>Todos</MenuItem>
              {suppliers.suppliers && suppliers.suppliers.map(s => <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, width: '25ch' }} >
            <Tags inputRef={tagsRef} defaultTags={["FBM", "FBA", "fbm", "fba", "FBS", "fbs"]}/>
          </FormControl>
          <FormControl sx={{ m: 1, width: '25ch' }} >
            <FormControlLabel control={<Switch inputRef={switchRef} />} label="Sincronizar?" />
          </FormControl>
          <DropZone accept=".xlsx" setFiles={setFiles}/>
          <Button disabled={roleCheck(user_roles)?(!flag || disabled ):"true"} onClick={submitFile} variant="contained" color="primary">
            {disabled?<CircularProgress size={27}/>:'Actualizar'}
          </Button>
          
        </Paper>:
        <Alert variant="filled" severity="warning">
        Tu usuario no tiene acceso a esta sección.
      </Alert>
      }
    </div>
  )
}

export default UpdateProductCosts